import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { queryIdentifier } from "../api/identifierApi";
// import { queryIdentifier } from "../apis/apiFunctions";

type IdentifiersDialogsStoreField = {
  showManageIdentifierPop: boolean;
  showSingleManageIdentifierPop: boolean;
  openBulkIdentifierDialog: boolean;
  successCount: number;
  initFilterList: any;
  associatedXevmpdId: string;//using recordId for xevmpd
};

type IdentifiersDialogsStoreState = IdentifiersDialogsStoreField & {
  onSingleIdentifierSuccess: () => void;
  openSingleIdentifier: (newList: any, associatedXevmpdId: string) => void;
  updateShowManageIdentifierPop: (newValue: boolean) => void;
  updateShowSingleManageIdentifierPop: (newValue: boolean) => void;
  updateOpenBulkIdentifierDialog: (newValue: boolean) => void;
  openManageIdentifierPop: () => void;
  closeManageIdentifierPop: () => void;
  closeSingleIdentifierPop: () => void;
  onBatchIdentifierSuccess: (newCount: number) => void;
  handleClickSingleIdentifier: (xevmpdId: string) => Promise<void>;
};

const useIdentifiersDialogsStore = create<IdentifiersDialogsStoreState>()(
  subscribeWithSelector(
    immer((set, get) => ({
      showManageIdentifierPop: false,
      showSingleManageIdentifierPop: false,
      openBulkIdentifierDialog: false,
      successCount: 0,
      initFilterList: null,
      associatedXevmpdId: "",
      openManageIdentifierPop() {
        set((state) => {
          state.showManageIdentifierPop = true;
          state.initFilterList = null;
        });
      },
      updateShowManageIdentifierPop(newValue) {
        set((state) => {
          state.showManageIdentifierPop = newValue;
        });
      },
      closeManageIdentifierPop() {
        set((state) => {
          state.showManageIdentifierPop = false;
          state.initFilterList = null;
        });
      },
      updateShowSingleManageIdentifierPop(newValue) {
        set((state) => {
          state.showSingleManageIdentifierPop = newValue;
        });
      },
      closeSingleIdentifierPop() {
        set((state) => {
          state.showSingleManageIdentifierPop = false;
          state.initFilterList = null;
        });
      },
      openSingleIdentifier(newList, associatedXevmpdId) {
        set((state) => {
          state.showSingleManageIdentifierPop = true;
          state.initFilterList = newList;
          state.associatedXevmpdId = associatedXevmpdId;
        })
      },
      onSingleIdentifierSuccess() {
        set((state) => {
          state.initFilterList = null;
          state.showSingleManageIdentifierPop = false;
        })
      },
      onBatchIdentifierSuccess(newCount) {
        set((state) => {
          state.successCount = newCount;
          state.showManageIdentifierPop = false;
          state.openBulkIdentifierDialog = true;
          state.initFilterList = null;
        });
      },
      updateOpenBulkIdentifierDialog(newValue) {
        set((state) => {
          state.openBulkIdentifierDialog = newValue;
        })
      },
      async handleClickSingleIdentifier(xevmpdId: string) {
        // currentData.current = _currentData;
        // setCurrentData(_currentData);
        // setAnchorMenuEl(null);
        // setLoading(true);
        let parameters = {
          xevmpdIds: [xevmpdId],
        };
        let identifiers = {};
        await queryIdentifier(parameters)
          .then((response) => {
            if (response.data?.data?.length) {
               identifiers = JSON.parse(response.data.data[0]?.identifierJson ?? {});  
            }
            get().openSingleIdentifier(identifiers, xevmpdId);
          }).catch(() => { });
      }
    }))
  )
);

export default useIdentifiersDialogsStore;
